import { computed, ref } from 'vue'
import { updateSentryContext } from '@/utils/sentry'
import { ADMIN_ROLE_NAME, OWNER_ROLE_NAME, type User } from '../model'
import { isInternalUser } from '@/modules/auth/utils/is-internal-user'

const user = ref<User | null>(null)

const setUser = (newUser: User) => {
    updateSentryContext(newUser)
    user.value = newUser
}

export default function useUser() {
    return {
        user: computed(() => user.value),
        organization: computed(() => user.value?.organization),
        isSignedIn: computed(() => !!user.value),
        isCurrentUserInternal: computed(() => {
            return user.value?.email ? isInternalUser(user.value.email) : false
        }),
        isOwner: computed(() => user.value?.role.name === OWNER_ROLE_NAME),
        isAdmin: computed(() => user.value?.role.name === ADMIN_ROLE_NAME),
        setUser,
    }
}
